export const supportConfig = {
    supportContact: process.env.REACT_APP_SUPPORT_CONTACT,
    supportAuxiliary: process.env.REACT_APP_SUPPORT_AUXILIARY,
    licensingContact: process.env.REACT_APP_LICENSING_CONTACT
}